module.exports = __webpack_public_path__ + "static/media/tpo-min.bdc8f627.png";